<div class="index-shell">
    <app-header [breadcrumbs]="['System settings','Handback reasons']"
                [links]="['/settings/general-information', '/settings/handback-reasons']"
                mainHeading="Handback reasons">
        @if ((user()?.permissions?.permissions ?? []).includes('handbackReason.create')) {
            <div headingButton>
                <button class="add-button"
                        cll-icon-button
                        (click)="addHandbackReason()">
                    <cll-icon type="outlined">add</cll-icon>
                </button>
            </div>
        }
    </app-header>
    <div>
        <cll-horizontal-tabs
            [appearance]="'contained'"
            [tabItems]="tabItems"
            [currentTabId]="(currentTabId$ | async)!"
            (currentTabIdChange)="currentTabIdChange($event)" />
        <div class="search-container">
            <cll-form-field label="Type a keyword...">
                <cll-icon cllPrefix>search</cll-icon>
                <input [formControl]="searchControl"
                       cllFormInput
                       type="text">

                @if (searchControl.value) {
                    <button (click)="searchControl.reset()"
                            cll-icon-button
                            cllTooltip="Clear search query"
                            cllSuffix>
                        <cll-icon>clear</cll-icon>
                    </button>
                }
            </cll-form-field>
        </div>


        @if (pageResult(); as request) {
            @if (request.isLoading) {
                <cll-spinner />
            }

            @if (request.error; as error) {
                <app-error-panel [error]="error" />
            }

            @if (request.value; as page) {

                <div class="panel-container">
                    <cll-panel-tonal colour="info">
                        <cll-icon cllPanelIcon>info</cll-icon>
                        <div class="panel-text-group">
                            <span class="panel-text-header">Information</span>
                            <span class="panel-text-sub-header">These reasons are system wide, not bound to permissions, once added all users can use them. </span>
                        </div>
                    </cll-panel-tonal>
                </div>

                <table class="cll-table">
                    <colgroup>
                        <col style="width: 48px;">
                    </colgroup>

                    <thead>
                    <tr>
                        <th>Name</th>
                        <th>Description</th>
                        <th>Status</th>
                        <th></th>
                    </tr>
                    </thead>

                    <tbody>
                        @if (page.data.length === 0) {
                            <tr>
                                <td colspan="4" class="no-data-row">
                                  <div class="no-data-wrapper">
                                    No Handback Reasons found.
                                  </div>
                                </td>
                              </tr>
                          } @else {
                        @for (handbackReasons of page.data; track handbackReasons.id) {
                            <tr class="clickable">
                                <td>{{ handbackReasons.name }}</td>
                                <td>{{ handbackReasons.description }}</td>
                                <td>

                                    @if (handbackReasons.status) {
                                        <cll-badge colour="success">Active</cll-badge>
                                    } @else {
                                        <cll-badge colour="error">Inactive</cll-badge>
                                    }

                                </td>
                                <td class="align-right">
                                    @if ((user()?.permissions?.permissions ?? []).includes('handbackReason.update')) {
                                        <button cll-icon-button
                                                [cllMenuTriggerFor]="menu"
                                                (click)="$event.stopPropagation()">
                                            <cll-icon>more_vert</cll-icon>
                                        </button>

                                        <ng-template #menu>
                                            <cll-menu>
                                                @if (handbackReasons.status) {
                                                    <button cllMenuItem (click)="editHandbackReason(handbackReasons)">
                                                        <cll-icon type="outlined">edit</cll-icon>
                                                        Edit
                                                    </button>
                                                    @if (user()?.permissions?.permission_name?.includes('Administrator')) {
                                                        <button cllMenuItem
                                                                (click)="changeStatus(handbackReasons, false)">
                                                            <cll-icon type="outlined">toggle_off</cll-icon>
                                                            Mark as inactive
                                                        </button>
                                                    }
                                                } @else {
                                                    @if (user()?.permissions?.permission_name?.includes('Administrator')) {
                                                        <button cllMenuItem
                                                                (click)="changeStatus(handbackReasons, true)">
                                                            <cll-icon type="outlined">toggle_on</cll-icon>
                                                            Mark as active
                                                        </button>
                                                    }
                                                }
                                            </cll-menu>
                                        </ng-template>
                                    }
                                </td>
                            </tr>
                        }
                    }
                    </tbody>
                </table>
            }
        }
    </div>

    <app-pagination-card
        (page)="setPage($event)"
        [meta]="meta()"
    />
</div>
